<template>
asi
</template>

<script>
export default {
  setup() {
    localStorage.clear()
  },
  mounted() {
  }
}
</script>
